import {ChangeDetectionStrategy, Component} from '@angular/core';
import {BiolinkEditorService} from '../biolink-editor.service';

@Component({
    selector: 'biolink-appearance',
    templateUrl: './biolink-appearance.component.html',
    styleUrls: ['./biolink-appearance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BiolinkAppearanceComponent {
    constructor(public editor: BiolinkEditorService) {}
}
